/* eslint-disable import/prefer-default-export */
import { createContext } from "react";

interface IJobFeedContext {
	Source: string;
	city: string;
	area: string;
	category: string;
	isLoggedIn: boolean;
	selectedJobFeedType: string;
	// TODO: can be strongly typed
	userPlatform: string;
	page: string;
}

export const JobFeedContext = createContext<IJobFeedContext>(null);
